<div class="mon-compte-page">
  <header class="account-header">
    <div class="header-spacer" aria-hidden="true"></div>
    <h1 class="header-title">Mon compte</h1>
    <div class="header-spacer" aria-hidden="true"></div>
  </header>

  <div class="page-content">
    <a class="profile-card" routerLink="/profil">
      <div class="avatar-container">
        @if (getProfileDisplayImage()) {
        <img
          [src]="getProfileDisplayImage() | versionedImageUrl : user()?.profileImageUpdatedAt"
          alt="Photo de profil"
          class="avatar"
        />
        } @else {
        <div class="avatar-placeholder">
          <span>{{ getInitials() }}</span>
        </div>
        }
      </div>

      <div class="profile-info">
        <h2 class="user-name">{{ displayName() }}</h2>
        <p class="user-city">Voir mon profil</p>
      </div>

      <span class="card-arrow">›</span>
    </a>

    @if (premiumActionsEnabled && !isPremium()) {
    <button type="button" class="premium-card" (click)="goToPremium()">
      <div class="premium-copy">
        <h3>Passer Premium</h3>
        <p class="premium-subtitle">Profitez de tous les avantages exclusifs !</p>
      </div>
      <div class="premium-stars" aria-hidden="true">
        <span class="star main">★</span>
        <span class="star small top">★</span>
        <span class="star small bottom">★</span>
      </div>
    </button>
    }

    <section class="section-block">
      <h3 class="section-title">Info complémentaire</h3>

      <a class="menu-row" routerLink="/faq">
        <img src="assets/icons/faq.svg" alt="" aria-hidden="true" class="menu-icon menu-icon-img" />
        <span class="menu-label">FAQ</span>
        <span class="card-arrow">›</span>
      </a>

      <a class="menu-row" routerLink="/contact">
        <img
          src="assets/icons/contact.svg"
          alt=""
          aria-hidden="true"
          class="menu-icon menu-icon-img"
        />
        <span class="menu-label">Contact</span>
        <span class="card-arrow">›</span>
      </a>
    </section>

    <section class="section-block">
      <h3 class="section-title">Cadre légal</h3>

      <a class="menu-row legal-row" routerLink="/mentions-legales">
        <span class="menu-icon legal-icon">⚖</span>
        <span class="menu-label">Mentions légales</span>
        <span class="card-arrow">›</span>
      </a>

      <a class="menu-row legal-row" routerLink="/cgu">
        <span class="menu-icon legal-icon">§</span>
        <span class="menu-label">CGU</span>
        <span class="card-arrow">›</span>
      </a>

      <a class="menu-row legal-row" routerLink="/politique-confidentialite">
        <span class="menu-icon legal-icon">◐</span>
        <span class="menu-label">Politique de confidentialité</span>
        <span class="card-arrow">›</span>
      </a>
    </section>

    <section class="section-block">
      <h3 class="section-title">Informations personnelles</h3>

      @if (canChangePassword()) {
      <a class="menu-row" routerLink="/mon-compte/changer-mot-de-passe">
        <span class="menu-icon lock-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <rect x="5" y="10" width="14" height="10" rx="2" />
            <path d="M8 10V7a4 4 0 0 1 8 0v3" />
          </svg>
        </span>
        <span class="menu-label">Modifier mon mot de passe</span>
        <span class="card-arrow">›</span>
      </a>
      } @if (premiumActionsEnabled) {
      <button type="button" class="menu-row" (click)="goToPremium()">
        <span class="menu-icon">✨</span>
        <span class="menu-label">{{
          isPremium() ? 'Changer mon abonnement' : 'Passer Premium'
        }}</span>
        <span class="card-arrow">›</span>
      </button>
      }

      <a class="menu-row danger" routerLink="/mon-compte/supprimer-compte">
        <span class="menu-icon">✕</span>
        <span class="menu-label">Supprimer mon compte</span>
        <span class="card-arrow">›</span>
      </a>
    </section>

    <button type="button" class="logout-btn" (click)="logout()">
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        aria-hidden="true"
      >
        <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />
      </svg>
      <span>Se déconnecter</span>
    </button>
  </div>

  <app-navbar></app-navbar>
</div>
